import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SvgModule } from '@shared/components/svg/svg.module';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { AngularResizeEventModule } from 'angular-resize-event';
import { SafeHtmlModule } from '@shared/pipes/safe-html/safe-html.module';
import { HoverableSvgModule } from '@shared/components/hoverable-svg/hoverable-svg.module';
import { MapModule } from '@shared/components/map/map.module';
import { LoaderModule } from '@shared/components/loader/loader.module';
import { RouterModule } from '@angular/router';
import { ImpairedIconModule } from '@impairedShared/impaired-icon/impaired-icon.module';
import { CatalogItemCardInfoComponent } from './components/catalog-item-card-info/catalog-item-card-info.component';
import { CatalogItemCardLinkModalComponent } from './components/catalog-item-card-link-modal/catalog-item-card-link-modal.component';
import { CatalogItemsModalComponent } from './components/catalog-items-modal/catalog-items-modal.component';
import { CatalogItemCardInfo2Component } from './components/catalog-item-card-info2/catalog-item-card-info2.component';
import { CatalogItemCardFilesModalComponent } from './components/catalog-item-card-files-modal/catalog-item-card-files-modal.component';
import { CatalogItemCardFilesInfoComponent } from './components/catalog-item-card-files-info/catalog-item-card-files-info.component';
import { DownloadLinkModule } from '../download-link/download-link.module';

@NgModule({
  declarations: [
    CatalogItemCardInfoComponent,
    CatalogItemCardLinkModalComponent,
    CatalogItemCardFilesModalComponent,
    CatalogItemCardFilesInfoComponent,
    CatalogItemsModalComponent,
    CatalogItemCardInfo2Component,
  ],
  imports: [
    CommonModule,
    SvgModule,
    NgLetModule,
    MatTooltipModule,
    TranslateModule,
    AngularResizeEventModule,
    ImpairedIconModule,
    SafeHtmlModule,
    HoverableSvgModule,
    MapModule,
    LoaderModule,
    RouterModule,
    DownloadLinkModule
  ],
  exports: [CatalogItemCardInfoComponent, CatalogItemCardInfoComponent, CatalogItemCardInfo2Component]
})
export class CatalogItemCardInfoModule {}
